<template>
  <transition name="modalbg">
    <div @click.self="closeModal" class="modal_container">
      <transition name="modal" v-on:before-leave="modalClose">
        <div v-if="showed" class="modal">
          <div class="caption">
            <div class="title-modal">{{textContent.titleAdd}}</div>
            <div @click="closeModal" class="close"></div>
          </div>
          <div class="modal-scroll" :class="{ 'in-last-tab' : isLastTab }">
            <div class="modal-content">
              <form v-on:submit.prevent="addItem">
                <form-input name="title"></form-input>
                <form-drop-down title="title" name="author_id" :id="parentId.authors"
                                :url="apiUrls.content"></form-drop-down>
                <div class="checkbox-group">
                  <checkbox name="show_author"></checkbox>
                  <checkbox name="show_date"></checkbox>
                </div>
                <form-drop-down title="title" name="parent_id" :id="parentId.activity"
                                :url="apiUrls.content"></form-drop-down>
                <form-file use-case="cover" name="img"></form-file>
                <form-input name="seo_alt"></form-input>
                <form-text-area name="subtext"></form-text-area>
                <form-text-editor name="text" editor-id="editor"></form-text-editor>
                <form-input name="seo_title"></form-input>
                <form-text-area name="seo_key"></form-text-area>
                <form-text-area name="seo_desc"></form-text-area>
              </form>
            </div>
          </div>
          <div class="buttons">
            <div class="next">
              <button @click="closeModal" class="cancel">{{textContent.cancelButton}}</button>
              <button class="confirm" @click="onAddItem">{{textContent.submitButton}}
              </button>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
  import IconAlignleft from '@/components/icons/IconAlignleft'
  import IconSignalbars from '@/components/icons/IconSignalbars'
  import IconArrowbold from '@/components/icons/IconArrowbold'
  import FormInput from '@/components/create-form/Input'
  import FormTextArea from '@/components/create-form/TextArea'
  import FormFile from '@/components/create-form/File'
  import FormDropDown from '@/components/create-form/DropDown'
  import FormTextEditor from '@/components/create-form/TextEditor'
  import {createNamespacedHelpers} from 'vuex'
  import Tabs from '@/components/create-form/Tabs'
  import Checkbox from '@/components/create-form/Checkbox'

  const {mapMutations, mapActions, mapState, mapGetters} = createNamespacedHelpers('mainPage')

  export default {
    data () {
      return {
        showed: false,
      }
    },
    computed: {
      ...mapState([
        'textContent',
        'fields'
      ]),
      ...mapGetters([
        'getDataFromEditor',
        'isLastTab'
      ]),
      apiUrls () {
        return this.$store.state.apiUrls
      },
      parentId () {
        return this.$store.state.parentId
      }
    },
    methods: {
      ...mapActions([
        'modalClose',
        'addItem',
        'initFields',
        'onNext',
        'onPrev',
        'checkTabAwailability',
        'addToNews'
      ]),
      ...mapMutations([
        'setField',
        'resetTextEditor',
        'setTabs',
        'setCurrentTabId',
        'setFileExtensions'
      ]),
      onAddItem () {
        this.setField({fieldId: 'text', fieldPropertyId: 'value', value: this.fields.text.editor.getData()})
        this.addItem()
        this.addToNews({
          title: this.fields.title.value,
          url: {
            path: 'oleg-malcev/nauchnaya-deyatelnost',
            categoryId: this.$route.path.split('/')[2]
          },
          img: this.fields.img.value,
          subtext: this.fields.subtext.value
        })
      },
      closeModal () {
        this.showed = false
      }
    },
    mounted () {
      this.showed = true
    },
    created () {
      this.setCurrentTabId(0)
      this.setFileExtensions({img: ['jpg', 'jpeg', 'png', 'gif']})
      this.initFields({
        title: {
          value: '',
          parameterName: 'title',
          name: 'Название статьи',
          errorId: null,
          errors: {empty: 'Введите название статьи'},
          tabId: 0
        },
        parent_id: {
          value: '',
          parameterName: 'parent_id',
          name: 'Категория',
          errorId: null,
          errors: {empty: 'Выберите категорию'},
          tabId: 0,
        },
        author_id: {
          value: '',
          parameterName: 'author_id',
          name: 'Автор',
          errorId: null,
          errors: {empty: 'Выберите автора'},
          tabId: 0,
          isNullable: true
        },
        show_author: {
          value: true,
          parameterName: 'show_author',
          name: 'Отображать автора',
          errorId: null,
          tabId: 0,
          isNullable: true
        },
        show_date: {
          value: true,
          parameterName: 'show_date',
          name: 'Отображать дату',
          errorId: null,
          tabId: 0,
          isNullable: true
        },
        img: {
          value: '',
          parameterName: 'img',
          name: 'Изображение',
          errorId: null,
          errors: {empty: 'Выберите изображение', extension: 'Допустимые расширения: jpg, jpeg, png, gif'},
          fileName: '',
          tabId: 0
        },
        subtext: {
          value: '',
          parameterName: 'subtext',
          name: 'Краткое описание',
          errorId: null,
          errors: {empty: 'Введите краткое описание'},
          tabId: 0,
        },
        text: {
          value: '',
          parameterName: 'text',
          name: 'Текст',
          errorId: null,
          errors: {empty: 'Введите текст'},
          tabId: 0,
        },
        seo_title: {
          value: '',
          parameterName: 'seo_title',
          name: 'Название страницы',
          errorId: null,
          errors: {empty: 'Напишите название страницы'},
          tabId: 0
        },
        seo_alt: {
          value: '',
          parameterName: 'seo_alt',
          name: 'Alt',
          errorId: null,
          errors: {empty: 'Напишите alt для картинки'},
          tabId: 0,
          isNullable: true
        },
        seo_key: {
          value: '',
          parameterName: 'seo_key',
          name: 'Ключевые слова',
          errorId: null,
          errors: {empty: 'Напишите ключевые слова'},
          tabId: 0,
          isNullable: true
        },
        seo_desc: {
          value: '',
          parameterName: 'seo_desc',
          name: 'Краткое описание',
          errorId: null,
          errors: {empty: 'Напишите краткое описание'},
          tabId: 0
        },
        content_id: {
          value: this.$store.state.parentId.activity,
          parameterName: 'content_id',
          errorId: null,
          isNullable: true,
        },
        object: {
          value: {},
          parameterName: 'object',
          errorId: null,
          isNullable: true,
        }
      })
    },
    components: {
      Checkbox,
      IconAlignleft,
      IconSignalbars,
      IconArrowbold,
      FormInput,
      FormTextArea,
      FormFile,
      FormDropDown,
      FormTextEditor,
      Tabs
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/activity/articles/CreateModal.vue